var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsRemediation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remediation__State=Remediation, Type=Enabled",
    className: "remediation__State=Remediation, remediation__Type=Enabled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remediation__Vector",
    className: "remediation__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.202 9.013a.656.656 0 0 0-.354.295l-.066.112-.014 2.292H7.526l-.12.056a.725.725 0 0 0-.201.148c-.168.192-.16.074-.16 2.028v1.764l.073.13a.66.66 0 0 0 .389.313c.063.016.5.025 1.182.025h1.08v1.101c0 1.207.002 1.214.146 1.396a.7.7 0 0 0 .21.16l.137.067h3.48l.137-.067a.7.7 0 0 0 .21-.16c.144-.182.145-.189.145-1.396v-1.101h1.081c.682 0 1.119-.01 1.182-.025a.666.666 0 0 0 .389-.313l.072-.13v-1.764c0-1.954.01-1.836-.159-2.028a.726.726 0 0 0-.2-.148l-.121-.056h-2.242l-.007-1.146c-.007-1.13-.008-1.147-.06-1.245a.697.697 0 0 0-.376-.31c-.172-.05-3.426-.05-3.591.002Zm.828 1.241c-.006.017-.014.539-.018 1.16l-.006 1.132-.08.117a.7.7 0 0 1-.338.27c-.057.019-.413.027-1.182.027h-1.1v1.968h2.247l.124.062a.688.688 0 0 1 .197.154c.147.185.144.158.144 1.38v1.116h1.966l.007-1.146c.008-1.277-.001-1.208.179-1.388.18-.18.15-.177 1.406-.178h1.122V12.96h-2.22l-.12-.057a.68.68 0 0 1-.306-.276c-.054-.087-.054-.093-.06-1.245l-.008-1.158h-.972c-.755 0-.974.007-.982.03Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.566 2.628a2.6 2.6 0 0 0-.19 1.5H5.47a.5.5 0 0 0-.5.5v16.28a.5.5 0 0 0 .5.5h13.064a.5.5 0 0 0 .5-.5V4.627a.5.5 0 0 0-.5-.5h-1.91a2.633 2.633 0 0 0-.189-1.5h2.1a2 2 0 0 1 2 2v16.28a2 2 0 0 1-2 2H5.468a2 2 0 0 1-2-2V4.627a2 2 0 0 1 2-2h2.097Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.66 2.582H9.34a.5.5 0 0 0-.5.5v1.22a.5.5 0 0 0 .5.5h5.32a.5.5 0 0 0 .5-.5v-1.22a.5.5 0 0 0-.5-.5Zm-5.32-1.5a2 2 0 0 0-2 2v1.22a2 2 0 0 0 2 2h5.32a2 2 0 0 0 2-2v-1.22a2 2 0 0 0-2-2H9.34Z",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsRemediation);
export default __webpack_public_path__ + "static/media/sidebar-icons-remediation.5c3da115f33c4cb23948ff70bd2bbd8e.svg";
export { ForwardRef as ReactComponent };